import { getAxiosInstance } from '@utils/request';
import { Messages } from '@datum-group/isogd-openapi/lib/models/messages';

export class APISendMessages {
  readonly url = 'api/messages';

  async add(value: { sender: string; email: string; text: string }) {
    let data = new FormData();
    data.append('sender', value.sender);
    data.append('email', value.email);
    data.append('text', value.text);
    const response = await getAxiosInstance().post<Messages>(
      `${this.url}/`,
      data,
    );

    return response;
  }
}
